import React from 'react';
import './LanguageSwitch.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";


class LanguageSwitch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            languages: this.props.languages,
            modalOpen: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            this.setState({ language: this.props.language });
        }
    }

    openModal = () => {
        this.setState({ modalOpen: true });
    }

    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    changeLanguage = (lang, langName) => {
        if (this.props.onLanguageChange && lang !== this.state.language) {
            this.props.onLanguageChange(lang);
            this.announceLanguageChange(langName);
        }
        this.setState({ modalOpen: false });
    }

    announceLanguageChange = (langName) => {
        const announcement = document.createElement('div');
        announcement.setAttribute('role', 'status');
        announcement.setAttribute('aria-live', 'polite');
        announcement.className = 'sr-only';
        announcement.textContent = `Language changed to ${langName}`;
        document.body.appendChild(announcement);
        setTimeout(() => announcement.remove(), 1000);
    }

    getCurrentLanguageName() {
        const current = this.state.languages.find(l => l.locale === this.state.language);
        return current ? current.name : 'English';
    }

    render() {
        return (
            <nav role="navigation" aria-label="Choose language">
                {/* Compact trigger button showing current language */}
                <button
                    className="lang-trigger-btn"
                    onClick={this.openModal}
                    aria-label="Change language"
                    type="button"
                >
                    <FontAwesomeIcon icon={faGlobe} className="lang-trigger-icon" />
                    <span className="lang-trigger-name">{this.getCurrentLanguageName()}</span>
                </button>

                {/* Full-screen modal for language selection */}
                {this.state.modalOpen && (
                    <>
                        <div className="lang-modal-backdrop" onClick={this.closeModal} />
                        <div className="lang-modal" role="dialog" aria-label="Select language">
                            <div className="lang-modal-header">
                                <span className="lang-modal-title">
                                    <FontAwesomeIcon icon={faGlobe} style={{ marginRight: '8px', opacity: 0.7 }} />
                                    Language
                                </span>
                                <button
                                    className="lang-modal-close"
                                    onClick={this.closeModal}
                                    aria-label="Close"
                                    type="button"
                                >
                                    ✕
                                </button>
                            </div>
                            <div className="lang-modal-grid" role="group">
                                {this.state.languages.map((lang) =>
                                    <button
                                        key={lang.locale}
                                        onClick={() => this.changeLanguage(lang.locale, lang.name)}
                                        className={"lang-card" + (lang.locale === this.state.language ? " active" : "")}
                                        aria-label={`Change language to ${lang.name}`}
                                        aria-current={lang.locale === this.state.language ? "true" : undefined}
                                        type="button"
                                    >
                                        <span className="lang-card-name">{lang.name}</span>
                                        <span className="lang-card-code">{lang.locale.toUpperCase()}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </nav>
        )
    };
}

export default LanguageSwitch;